export const selectBarcodeImage = state => state.barcode.imageUrl;
